'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Button, Card, CardBody } from '@nextui-org/react';
import { BasilEnvelopeOutline } from '@/components/icons/footer/BasilEnvelopeOutline';

const InMailContactForm = () => {
  const t = useTranslations('contact');
  const onCreateMail = () => {
    const email = 'info@greenconceptors.com';
    window.location.href = `mailto:${email}?subject=${t(
      'form.inquiry.subject'
    )}&body=${encodeURIComponent(t('form.inquiry.body'))}`;
  };

  return (
    <Card className="h-full">
      <CardBody className="flex-1 flex flex-col items-center justify-center py-10">
        <BasilEnvelopeOutline className="h-20 w-20 text-[var(--app-color-green)]" />
        <span className="text-lg font-semibold">{t('form.heading')}</span>
        <p className="text-default-500 text-center">{t('form.description')}</p>
        <Button
          variant="bordered"
          onPress={onCreateMail}
          className="hover:border-app-lime mt-4 min-w-28"
        >
          {t('form.button.send')}
        </Button>
      </CardBody>
    </Card>
  );
};

export default InMailContactForm;
